import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'

type TopbarProps = {
  setContentContainerRef: (el: HTMLDivElement | null) => void
}

export function Topbar(props: TopbarProps) {
  const { setContentContainerRef } = props
  return (
    <AppBar position="fixed" sx={{ pl: '34px', pr: '34px', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar disableGutters ref={setContentContainerRef}></Toolbar>
    </AppBar>
  )
}

export default Topbar
